import React from 'react';

import BaseInventoryTagSpan from './BaseInventoryTagSpan';
import * as Icons from '../icons/Icons';


export class InventoryCamping extends BaseInventoryTagSpan { }
InventoryCamping.defaultProps = {
    tagIconName: <Icons.IconTent alt="Camping" />,
    name: "Camping",
    iconClass: "camping"
};

export class InventoryRecArea extends BaseInventoryTagSpan { }
InventoryRecArea.defaultProps = {
    tagIconName: <Icons.IconTree alt="Recreation Area" />,
    name: "Recreation Area",
    iconClass: "rec-area"
};

export class InventoryTicket extends BaseInventoryTagSpan { }
InventoryTicket.defaultProps = {
    tagIconName: <Icons.IconTicket alt="Tickets and Tours" />,
    name: "Tickets and Tours",
    iconClass: "tickets-tours"
};

export class InventoryPass extends BaseInventoryTagSpan { }
InventoryPass.defaultProps = {
    tagIconName: <Icons.IconCard alt="Passes" />,
    name: "Passes",
    iconClass: "pass"
};

export class InventoryPOI extends BaseInventoryTagSpan { }
InventoryPOI.defaultProps = {
    tagIconName: <Icons.IconCompass alt="Point of Interest" />,
    name: "Point of Interest",
    iconClass: "poi"
};

export class InventoryDayUse extends BaseInventoryTagSpan { }
InventoryDayUse.defaultProps = {
    tagIconName: <Icons.IconPicnicTable alt="Day Use" />,
    name: "Day Use",
    iconClass: "day-use"
};

export class InventoryLottery extends BaseInventoryTagSpan { }
InventoryLottery.defaultProps = {
    tagIconName: <Icons.IconLottery alt="Lottery" />,
    name: "Lottery",
    iconClass: "lottery"
};

export class InventoryRental extends BaseInventoryTagSpan { }
InventoryRental.defaultProps = {
    tagIconName: <Icons.IconRental alt="Rental" />,
    name: "Rental",
    iconClass: "rental"
};

export class InventoryPermit extends BaseInventoryTagSpan { }
InventoryPermit.defaultProps = {
    tagIconName: <Icons.IconPermit alt="Permits" />,
    name: "Permits",
    iconClass: "permit"
};

export class InventoryVehiclePermit extends BaseInventoryTagSpan { }
InventoryVehiclePermit.defaultProps = {
    tagIconName: <Icons.IconVehiclePermit alt="Vehicle Permit" />,
    name: "Vehicle Permit",
    iconClass: "vehicle-permit"
};
